module.exports = __webpack_public_path__ + "static/citywide-splash-optimised-4a3bc5da7ade818e3eec6cd75f7adf7d.svg";